import { render, staticRenderFns } from "./_bulk_version_request.vue?vue&type=template&id=a8670598&scoped=true&"
import script from "./_bulk_version_request.vue?vue&type=script&lang=js&"
export * from "./_bulk_version_request.vue?vue&type=script&lang=js&"
import style0 from "./_bulk_version_request.vue?vue&type=style&index=0&id=a8670598&lang=sass&scoped=true&"
import style1 from "./_bulk_version_request.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8670598",
  null
  
)

export default component.exports